// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__30tgb","colCheckbox":"styles_colCheckbox__1KzT7"};